/* Copyright (c) 2020-present CloudIO Inc */

import React, { lazy, Suspense } from 'react';
import SimpleLoading from 'root/SimpleLoading';

const WithTailwindLazy = lazy(
  () => import(/* webpackChunkName: "bs" */ './WithBootstrapLazy'),
);

export function WithBootstrap({ children }: { children: React.ReactNode }) {
  return (
    <Suspense fallback={<SimpleLoading name="WithBootstrap" />}>
      <WithTailwindLazy>{children}</WithTailwindLazy>
    </Suspense>
  );
}
